import React, { useState, useEffect } from "react";
import {
    Box,
    Flex,
    Heading,
    Text,
    Input,
    Button,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Badge,
    useToast,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    Spinner,
    Select,
    SimpleGrid,
    Stat,
    StatLabel,
    StatNumber,
    ButtonGroup,
    AlertDialog,
    AlertDialogBody,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogContent,
    AlertDialogOverlay,
    Switch,
    VStack,
    HStack,
    IconButton,
    Wrap,
    WrapItem,
    Tag,
    Tooltip,
} from "@chakra-ui/react";
import {
    AddIcon,
    EditIcon,
    DeleteIcon,
    CloseIcon,
} from "@chakra-ui/icons";
import customerSlice, { get_all_customer_list } from "../../redux/customerSlice";

import { useDispatch, useSelector } from "react-redux";
import {
    create_coupon,
    update_coupon,
    fetch_coupons,
    delete_coupon,
    resetCouponState,
} from "../../redux/couponSlice";
import { get_product_list } from "../../redux/productSlice";
import store from "../../redux/store";
import GasCylinderLoader from "../../components/GasCylinderLoader";

const Coupon = () => {
    const dispatch = useDispatch();
    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const {
        isOpen: isDeleteOpen,
        onOpen: onDeleteOpen,
        onClose: onDeleteClose,
    } = useDisclosure();
    const cancelRef = React.useRef();

    const { loading, success, error, message, coupons, summary, totalCount } =
        useSelector((state) => state.coupon);

    const { product_list } = useSelector((state) => state.products);

    const [isEditMode, setIsEditMode] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedFilter, setSelectedFilter] = useState("All");
    const [deleteId, setDeleteId] = useState(null);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [availableProducts, setAvailableProducts] = useState([]);
    const [usedProductCodes, setUsedProductCodes] = useState(new Set());
    const { all_customer_list } = useSelector((state) => state.customers);

    const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
    
    const [formData, setFormData] = useState({
        id: "",
        coupon_code: "",
        description: "",
        discount_amount: "",
        validity: "",
        status: true,
    });

    // Fetch coupons and products on mount
    useEffect(() => {
        dispatch(fetch_coupons({ page: currentPage, limit: 10 }));
        store.dispatch(get_product_list({ page: 1, rows: 1000 }));
    }, [dispatch, currentPage]);


    const getProductDetails = (couponProducts) => {
        if (!Array.isArray(couponProducts)) return [];

        return couponProducts.map((cp) => {
            const match = product_list?.find(
                (p) => p.product_code === cp.prod_code
            );
            return match
                ? { name: match.name, rsp: match.rsp }
                : { name: cp.product_name, rsp: "N/A" };
        });
    };

    useEffect(() => {
        dispatch(fetch_coupons({ page: currentPage, limit: 10 }));
        store.dispatch(get_product_list({ page: 1, rows: 1000 }));
        store.dispatch(get_all_customer_list()); // 👈 Fetch all customers
      }, [dispatch, currentPage]);
      
    // Extract used product codes from all coupons
    useEffect(() => {
        if (coupons && coupons.length > 0) {
            const usedCodes = new Set();
            coupons.forEach((coupon) => {
                if (coupon.prod_code) {
                    if (Array.isArray(coupon.prod_code)) {
                        coupon.prod_code.forEach(code => usedCodes.add(code));
                    } else if (typeof coupon.prod_code === 'string') {
                        usedCodes.add(coupon.prod_code);
                    }
                }
                if (coupon.product_codes) {
                    if (Array.isArray(coupon.product_codes)) {
                        coupon.product_codes.forEach(code => usedCodes.add(code));
                    }
                }
            });
            setUsedProductCodes(usedCodes);
        }
    }, [coupons]);

    // Update available products when product_list changes or usedProductCodes changes
    useEffect(() => {
        if (product_list && product_list.length > 0) {
            const products = product_list
                .filter((p) => !usedProductCodes.has(p.product_code))
                .map((p) => ({
                    product_code: p.product_code,
                    name: p.name,
                    type: p.type,
                    rsp: p.rsp,
                }));
            setAvailableProducts(products);
        }
    }, [product_list, usedProductCodes]);

    // Filter coupons based on status and validity
    const filteredCoupons = coupons.filter((coupon) => {
        if (selectedFilter === "All") return true;

        const now = new Date();
        const validity = new Date(coupon.validity);
        const isExpired = validity < now;

        if (selectedFilter === "Active") {
            return coupon.status === "1" && !isExpired;
        }
        if (selectedFilter === "Inactive") {
            return coupon.status === "0" && !isExpired;
        }
        if (selectedFilter === "Expired") {
            return isExpired;
        }

        return true;
    });


    // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Handle status toggle
    const handleStatusToggle = (checked) => {
        setFormData((prev) => ({ ...prev, status: checked }));
    };

    const handleProductSelect = (e) => {
        const selectedCode = e.target.value;
        if (!selectedCode) return;

        const product = availableProducts.find((p) => p.product_code === selectedCode);
        console.log(product,"this is pr")
        if (product) {
            setSelectedProducts((prev) => [...prev, product]);
            setAvailableProducts((prev) =>
                prev.filter((p) => p.product_code !== selectedCode)
            );
        }
    };
console.log(availableProducts,"this are avail")
    // Handle product removal
    const handleRemoveProduct = (productCode) => {
        const product = selectedProducts.find((p) => p.product_code === productCode);
        if (product) {
            setSelectedProducts((prev) =>
                prev.filter((p) => p.product_code !== productCode)
            );
            if (!usedProductCodes.has(productCode)) {
                setAvailableProducts((prev) => [...prev, product]);
            }
        }
    };

    // Open modal for creating coupon
    const handleOpenCreate = () => {
        setIsEditMode(false);
        setFormData({
            id: "",
            coupon_code: "",
            description: "",
            discount_amount: "",
            validity: "",
            status: true, // Always active when creating new coupon
        });
        setSelectedProducts([]);

        if (product_list && product_list.length > 0) {
            const products = product_list
                .filter((p) => !usedProductCodes.has(p.product_code))
                .map((p) => ({
                    product_code: p.product_code,
                    name: p.name,
                    rsp: p.rsp,
                    type:p.type,
                }));
            setAvailableProducts(products);
        }
        onOpen();
    };

    // Open modal for editing coupon
    const handleOpenEdit = (coupon) => {
        setIsEditMode(true);
        const formattedValidity = coupon.validity
            ? coupon.validity.replace(" ", "T").substring(0, 16)
            : "";

        // Check if coupon is expired
        const now = new Date();
        const validity = new Date(coupon.validity);
        const isExpired = validity < now;

        // Determine actual status
        let actualStatus = false;
        if (!isExpired && coupon.status === "1") {
            actualStatus = true;
        }

        setFormData({
            id: coupon.id,
            coupon_code: coupon.coupon_code,
            description: coupon.description,
            discount_amount: coupon.discount_amount,
            validity: formattedValidity,
            status: actualStatus,
        });

        const couponProducts = [];
        // Handle different product data structures
        const productCodes = coupon.prod_code || coupon.product_codes || [];
        const productsData = coupon.products || [];

        if (Array.isArray(productCodes) && productCodes.length > 0) {
            productCodes.forEach(code => {
                const product = product_list.find(p => p.product_code === code);
                if (product) {
                    couponProducts.push({
                        product_code: product.product_code,
                        name: product.name,
                        rsp: product.rsp,
                    });
                }
            });
        } else if (Array.isArray(productsData) && productsData.length > 0) {
            productsData.forEach(prod => {
                const product = product_list.find(p => p.product_code === prod.prod_code);
                if (product) {
                    couponProducts.push({
                        product_code: product.product_code,
                        name: product.name,
                        rsp: product.rsp,
                    });
                }
            });
        }
        
        setSelectedProducts(couponProducts);

        const editingCouponCodes = new Set(couponProducts.map(p => p.product_code));
        const otherUsedCodes = new Set([...usedProductCodes].filter(code => !editingCouponCodes.has(code)));

        const products = product_list
            .filter((p) => !otherUsedCodes.has(p.product_code) && !editingCouponCodes.has(p.product_code))
            .map((p) => ({
                product_code: p.product_code,
                name: p.name,
                rsp: p.rsp,
            }));
        setAvailableProducts(products);

        onOpen();
    };

    // Open delete confirmation dialog
    const handleOpenDelete = (id) => {
        setDeleteId(id);
        onDeleteOpen();
    };

    // Handle delete coupon
    const handleDelete = () => {
        if (deleteId) {
            dispatch(delete_coupon(deleteId));
            onDeleteClose();
        }
    };

    // Handle form submit
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (selectedProducts.length === 0) {
            toast({
                title: "Error",
                description: "Please select at least one product",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            return;
        }

        const formattedData = {
            ...formData,
            validity: formData.validity.replace("T", " ") + ":00",
            status: formData.status ? "1" : "0",
            prod_code: selectedProducts.map((p) => p.product_code),
            customer_id: selectedCustomerIds, // 👈 Add this line
          };
          

        if (isEditMode) {
            dispatch(update_coupon(formattedData));
        } else {
            dispatch(create_coupon(formattedData));
        }
    };

    // Toasts and reset after submission
    useEffect(() => {
        if (success) {
            toast({
                title: "Success!",
                description: message,
                status: "success",
                duration: 3000,
                isClosable: true,
            });
            onClose();
            setFormData({
                id: "",
                coupon_code: "",
                description: "",
                discount_amount: "",
                validity: "",
                status: true,
            });
            setSelectedProducts([]);
            dispatch(resetCouponState());
            dispatch(fetch_coupons({ page: currentPage, limit: 10 }));
        } else if (error) {
            toast({
                title: "Error",
                description: error,
                status: "error",
                duration: 3000,
                isClosable: true,
            });
            dispatch(resetCouponState());
        }
    }, [success, error, message, toast, onClose, dispatch, currentPage]);

    const handleCustomerSelect = (e) => {
        const value = e.target.value;
        if (value && !selectedCustomerIds.includes(value)) {
          setSelectedCustomerIds((prev) => [...prev, value]);
        }
      };
      const handleRemoveCustomer = (id) => {
        setSelectedCustomerIds((prev) => prev.filter((cid) => cid !== id));
      };

      
    return (
        <Box bg="gray.50" minH="100vh" p={1}>
            {/* Header */}
            <Box bg={"white"} color="white" p={5} borderRadius="md" boxShadow="md">
                <Heading size="md" color="black">
                    🎫 Coupon Code Management
                </Heading>
                <Text fontSize="sm" color="gray.700">
                    Create, manage, and track promotional coupon codes
                </Text>
            </Box>

            {/* Summary Cards */}
            {summary && (
                <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} spacing={4} mt={6}>
                    <Box bg="white" p={4} borderRadius="lg" boxShadow="sm">
                        <Stat>
                            <StatLabel>Total Coupons</StatLabel>
                            <StatNumber color="purple.600">
                                {summary["Total Coupons"] || 0}
                            </StatNumber>
                        </Stat>
                    </Box>
                    <Box bg="white" p={4} borderRadius="lg" boxShadow="sm">
                        <Stat>
                            <StatLabel>Active Coupons</StatLabel>
                            <StatNumber color="green.600">
                                {summary["Active Coupons"] || 0}
                            </StatNumber>
                        </Stat>
                    </Box>
                    <Box bg="white" p={4} borderRadius="lg" boxShadow="sm">
                        <Stat>
                            <StatLabel>Total Usage</StatLabel>
                            <StatNumber color="blue.600">
                                {summary["Total Usage"] || 0}
                            </StatNumber>
                        </Stat>
                    </Box>
                    <Box bg="white" p={4} borderRadius="lg" boxShadow="sm">
                        <Stat>
                            <StatLabel>Total Discount Given</StatLabel>
                            <StatNumber color="orange.600">
                                ₹{summary["Total Discount Given"] || 0}
                            </StatNumber>
                        </Stat>
                    </Box>
                </SimpleGrid>
            )}

            {/* Filter Tabs and Create Button */}
            <Flex justify="space-between" align="center" mt={6} flexWrap="wrap" gap={4}>
                <ButtonGroup spacing={2}>
                    <Button
                        size="sm"
                        colorScheme={selectedFilter === "All" ? "blue" : "gray"}
                        variant={selectedFilter === "All" ? "solid" : "outline"}
                        onClick={() => setSelectedFilter("All")}
                    >
                        All
                    </Button>
                    <Button
                        size="sm"
                        colorScheme={selectedFilter === "Active" ? "blue" : "gray"}
                        variant={selectedFilter === "Active" ? "solid" : "outline"}
                        onClick={() => setSelectedFilter("Active")}
                    >
                        Active
                    </Button>
                    <Button
                        size="sm"
                        colorScheme={selectedFilter === "Inactive" ? "blue" : "gray"}
                        variant={selectedFilter === "Inactive" ? "solid" : "outline"}
                        onClick={() => setSelectedFilter("Inactive")}
                    >
                        Inactive
                    </Button>
                    <Button
                        size="sm"
                        colorScheme={selectedFilter === "Expired" ? "blue" : "gray"}
                        variant={selectedFilter === "Expired" ? "solid" : "outline"}
                        onClick={() => setSelectedFilter("Expired")}
                    >
                        Expired
                    </Button>
                </ButtonGroup>

                <Button
                    leftIcon={<AddIcon />}
                    colorScheme="green"
                    size="sm"
                    onClick={handleOpenCreate}
                >
                    Create Coupon
                </Button>
            </Flex>

            {/* Table */}
            <Box
                bg="white"
                borderWidth="1px"
                borderRadius="xl"
                mt={4}
                overflowX="auto"
                p={4}
            >
                {loading && coupons.length === 0 ? (
                    <GasCylinderLoader
                    size="sm"
        loadingText="Loading Coupons..."
                    />
                ) : filteredCoupons.length === 0 ? (
                    <Flex
                        direction="column"
                        justify="center"
                        align="center"
                        minH="200px"
                        gap={2}
                    >
                        <Text fontSize="3xl">🎫</Text>
                        <Text color="gray.500" fontWeight="medium">
                            No coupons found
                        </Text>
                        <Text color="gray.400" fontSize="sm">
                            Create, manage, and track promotional coupon codes
                        </Text>
                    </Flex>
                ) : (
                    <Table variant="simple" size="sm">
                        <Thead bg="gray.100">
                            <Tr>
                                <Th>Code</Th>
                                <Th>Description</Th>
                                <Th>Type</Th>
                                <Th>Products</Th>
                                <Th>Discount (₹)</Th>
                                <Th>Created At</Th>
                                <Th>Validity</Th>
                                <Th>Status</Th>
                                <Th textAlign="center">Actions</Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {filteredCoupons.map((coupon) => {
                                const products = getProductDetails(coupon.products || []);
                                const now = new Date();
                                const validity = new Date(coupon.validity);
                                const isExpired = validity < now;
                                
                                let statusDisplay = "Inactive";
                                let statusColor = "red";
                                
                                if (isExpired) {
                                    statusDisplay = "Expired";
                                    statusColor = "yellow";
                                } else if (coupon.status === "1") {
                                    statusDisplay = "Active";
                                    statusColor = "green";
                                }
                                
                                return (
                                    <Tr key={coupon.id} _hover={{ bg: "gray.50" }}>
  {/* Coupon Code */}
  <Td color="purple.600" fontWeight="semibold">
    {coupon.coupon_code}
  </Td>

  {/* Description */}
  <Td maxW="200px">
    <Text noOfLines={2}>{coupon.description}</Text>
  </Td>

  {/* Product Type */}
  <Td>
    {coupon.products && coupon.products.length > 0 ? (
      coupon.products.map((p, i) => (
        <div key={i}>{p.type}</div>
      ))
    ) : (
      <span style={{ color: "gray" }}>No products found</span>
    )}
  </Td>

  {/* Product Name */}
  <Td>
    {coupon.products && coupon.products.length > 0 ? (
      coupon.products.map((p, i) => (
        <div key={i}>{p.product_name}</div>
      ))
    ) : (
      <span style={{ color: "gray" }}>No products found</span>
    )}
  </Td>

  {/* Discount Amount */}
  <Td fontWeight="semibold" color="green.600">
    ₹{coupon.discount_amount}
  </Td>

  {/* Created At */}
  <Td>{new Date(coupon.created_at).toLocaleDateString()}</Td>

  {/* Validity */}
  <Td>{new Date(coupon.validity).toLocaleDateString()}</Td>

  {/* Status */}
  <Td>
    <Badge colorScheme={statusColor}>{statusDisplay}</Badge>
  </Td>

  {/* Actions */}
  <Td textAlign="center">
    <Flex justify="center" gap={2}>
      <Button
        size="xs"
        leftIcon={<EditIcon />}
        colorScheme="blue"
        onClick={() => handleOpenEdit(coupon)}
      >
        Edit
      </Button>
      <Button
        size="xs"
        leftIcon={<DeleteIcon />}
        colorScheme="red"
        onClick={() => handleOpenDelete(coupon.id)}
      >
        Delete
      </Button>
    </Flex>
  </Td>
</Tr>

                                );
                            })}
                        </Tbody>
                    </Table>
                )}
            </Box>

            {/* Pagination Info */}
            {totalCount > 0 && (
                <Flex justify="center" mt={4}>
                    <Text fontSize="sm" color="gray.600">
                        Showing {filteredCoupons.length} of {totalCount} coupons
                    </Text>
                </Flex>
            )}

            {/* Create/Edit Coupon Modal */}
            <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
                <ModalOverlay />
                <ModalContent maxH="90vh" overflowY="auto">
                    <ModalHeader>
                        {isEditMode ? "Edit Coupon" : "Create New Coupon"}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <VStack spacing={4} align="stretch">
                            <FormControl isRequired>
                                <FormLabel>Coupon Code</FormLabel>
                                <Input
                                    name="coupon_code"
                                    value={formData.coupon_code}
                                    onChange={handleChange}
                                    placeholder="Enter coupon code"
                                />
                            </FormControl>

                            <FormControl isRequired>
                                <FormLabel>Description</FormLabel>
                                <Input
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    placeholder="Enter description"
                                />
                            </FormControl>
                            <FormControl isRequired>
  <FormLabel>Select Customer</FormLabel>
  <Select
    placeholder="Select customer"
    onChange={handleCustomerSelect}
    value=""
  >
    {all_customer_list.map((customer) => (
      <option key={customer.id} value={customer.id}>
        {customer.name ? customer.name : customer.business_name || customer.id} ({customer.mobile})
      </option>
    ))}
  </Select>

  {selectedCustomerIds.length > 0 && (
    <Wrap mt={2}>
      {selectedCustomerIds.map((id) => {
        const cust = all_customer_list.find((c) => c.id === id);
        return (
          <WrapItem key={id}>
            <Tag colorScheme="blue" borderRadius="full">
              <Text fontSize="sm" mr={1}>
              {cust.name ? cust.name : cust.business_name || cust.id }
              </Text>
              <IconButton
                icon={<CloseIcon />}
                size="xs"
                variant="ghost"
                onClick={() => handleRemoveCustomer(id)}
                aria-label="Remove customer"
              />
            </Tag>
          </WrapItem>
        );
      })}
    </Wrap>
  )}
</FormControl>

                            <FormControl>
                                <FormLabel>
                                    Select Products {selectedProducts.length === 0 && <Text as="span" color="red.500">*</Text>}
                                    {isEditMode && <Text as="span" fontSize="xs" color="gray.500" ml={2}>(Product selection disabled in edit mode)</Text>}
                                </FormLabel>
                                <Select
                                    placeholder="Select a product"
                                    onChange={handleProductSelect}
                                    value=""
                                    isInvalid={false}
                                    isDisabled={isEditMode}
                                >
                                    {availableProducts.map((product) => (
                                        <option key={product.product_code} value={product.product_code}>
                                         {product.type}-{product.name} ({product.product_code}) - RSP: ₹{product.rsp}
                                        </option>
                                    ))}
                                </Select>
                                {availableProducts.length === 0 && selectedProducts.length === 0 && !isEditMode && (
                                    <Text fontSize="xs" color="red.500" mt={1}>
                                        All products have been assigned to coupons
                                    </Text>
                                )}
                            </FormControl>

                            {/* Selected Products List */}
                            {selectedProducts.length > 0 && (
                                <Box
                                    borderWidth="1px"
                                    borderRadius="md"
                                    p={3}
                                    bg="gray.50"
                                    maxH="200px"
                                    overflowY="auto"
                                >
                                    <Text fontWeight="semibold" mb={2} fontSize="sm">
                                        Selected Products ({selectedProducts.length})
                                    </Text>
                                    <VStack spacing={2} align="stretch">
                                        {selectedProducts.map((product) => (
                                            <HStack
                                                key={product.product_code}
                                                justify="space-between"
                                                p={2}
                                                bg="white"
                                                borderRadius="md"
                                                borderWidth="1px"
                                            >
                                                <Box flex="1">
                                                    <Text fontSize="sm" fontWeight="medium">
                                                        {product.name}
                                                    </Text>
                                                    <Text fontSize="xs" color="gray.600">
                                                        Code: {product.product_code}
                                                    </Text>
                                                </Box>
                                                <Box textAlign="right">
                                                    <Text fontSize="sm" fontWeight="semibold" color="green.600">
                                                        RSP: ₹{product.rsp}
                                                    </Text>
                                                </Box>
                                                <IconButton
                                                    size="sm"
                                                    icon={<CloseIcon />}
                                                    colorScheme="red"
                                                    variant="ghost"
                                                    onClick={() => handleRemoveProduct(product.product_code)}
                                                    aria-label="Remove product"
                                                    isDisabled={isEditMode}
                                                />
                                            </HStack>
                                        ))}
                                    </VStack>
                                </Box>
                            )}

                            <FormControl isRequired>
                                <FormLabel>Discount Amount (₹)</FormLabel>
                                <Input
                                    type="number"
                                    name="discount_amount"
                                    value={formData.discount_amount}
                                    onChange={handleChange}
                                    placeholder="Enter discount amount in rupees"
                                    min="0"
                                    step="0.01"
                                />
                                <Text fontSize="xs" color="gray.500" mt={1}>
                                    Enter the discount amount in rupees (can be any amount)
                                </Text>
                            </FormControl>

                            <FormControl isRequired>
                                <FormLabel>Validity</FormLabel>
                                <Input
                                    type="datetime-local"
                                    name="validity"
                                    value={formData.validity}
                                    onChange={handleChange}
                                />
                            </FormControl>

                            <FormControl display="flex" alignItems="center">
                                <FormLabel htmlFor="status-toggle" mb="0">
                                    Status
                                </FormLabel>
                                <Switch
                                    id="status-toggle"
                                    isChecked={formData.status}
                                    onChange={(e) => handleStatusToggle(e.target.checked)}
                                    colorScheme="green"
                                    size="lg"
                                />
                                <Text ml={3} fontSize="sm" fontWeight="medium" color={formData.status ? "green.600" : "red.600"}>
                                    {formData.status ? "Active" : "Inactive"}
                                </Text>
                            </FormControl>
                        </VStack>
                    </ModalBody>

                    <ModalFooter>
                        <Button variant="ghost" mr={3} onClick={onClose}>
                            Cancel
                        </Button>
                        <Button
                            colorScheme="green"
                            onClick={handleSubmit}
                            isDisabled={loading || selectedProducts.length === 0}
                            leftIcon={loading && <Spinner size="sm" />}
                        >
                            {loading
                                ? isEditMode
                                    ? "Updating..."
                                    : "Creating..."
                                : isEditMode
                                    ? "Update"
                                    : "Create"}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Delete Confirmation Dialog */}
            <AlertDialog
                isOpen={isDeleteOpen}
                leastDestructiveRef={cancelRef}
                onClose={onDeleteClose}
                isCentered
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            Delete Coupon
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            Are you sure? You can't undo this action afterwards.
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onDeleteClose}>
                                Cancel
                            </Button>
                            <Button
                                colorScheme="red"
                                onClick={handleDelete}
                                ml={3}
                                isLoading={loading}
                            >
                                Delete
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
        </Box>
    );
};

export default Coupon;  